import { c as _c } from "react/compiler-runtime";
import Pagination from "@/components/pagination/Pagination";
import { MEMES_CONTRACT } from "@/constants";
import type { RedeemedSubscription } from "@/generated/models/RedeemedSubscription";
import type { SubscriptionLog } from "@/generated/models/SubscriptionLog";
import type { SubscriptionTopUp } from "@/generated/models/SubscriptionTopUp";
import { areEqualAddresses, formatAddress, getDateDisplay, getTransactionLink } from "@/helpers/Helpers";
import type { Page } from "@/helpers/Types";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { mainnet } from "wagmi/chains";
import EthereumIcon from "../utils/icons/EthereumIcon";
import EtherscanIcon from "../utils/icons/EtherscanIcon";
import styles from "./UserPageSubscriptions.module.scss";
export default function UserPageSubscriptionsHistory(props) {
  const $ = _c(15);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h5 className="mb-0 tw-font-semibold">Subscription History</h5></Col></Row>;
    t1 = <hr className="tw-border-white tw-opacity-100 tw-border-2 tw-mt-1" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.redeemed || $[3] !== props.setRedeemedPage) {
    t2 = <Row className="pb-2"><Col><RedeemedSubscriptionsAccordion history={props.redeemed} setPage={props.setRedeemedPage} /></Col></Row>;
    $[2] = props.redeemed;
    $[3] = props.setRedeemedPage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.logs || $[6] !== props.setLogsPage) {
    t3 = <Row className="pt-2 pb-2"><Col><LogAccordion logs={props.logs} setPage={props.setLogsPage} /></Col></Row>;
    $[5] = props.logs;
    $[6] = props.setLogsPage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props.setTopUpPage || $[9] !== props.topups) {
    t4 = <Row className="pt-2 pb-2"><Col><TopUpAccordion history={props.topups} setPage={props.setTopUpPage} /></Col></Row>;
    $[8] = props.setTopUpPage;
    $[9] = props.topups;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <Container className="no-padding">{t0}{t1}{t2}{t3}{t4}</Container>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function RedeemedSubscriptionsAccordion(props) {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Accordion.Button className={styles.topUpHistoryAccordionButton}><b>Redeemed Subscriptions</b></Accordion.Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.history.data) {
    t1 = props.history.data.length > 0 ? props.history.data.map(_temp) : <div className="font-color-silver">No Redeemed Subscriptions found</div>;
    $[1] = props.history.data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="d-flex flex-column gap-2">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.history.count || $[6] !== props.history.page || $[7] !== props.setPage) {
    t3 = props.history.count > 0 && props.history.count / 10 > 1 && <div className="text-center mt-3"><Pagination page={props.history.page} pageSize={10} totalResults={props.history.count} setPage={props.setPage} /></div>;
    $[5] = props.history.count;
    $[6] = props.history.page;
    $[7] = props.setPage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t0}<Accordion.Body className={styles.topUpHistoryAccordionBody}>{t2}{t3}</Accordion.Body></Accordion.Item></Accordion>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(redeem) {
  return <RedeemedEntry key={redeem.transaction} redeem={redeem} />;
}
function LogAccordion(props) {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Accordion.Button className={styles.topUpHistoryAccordionButton}><b>Log History</b></Accordion.Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.logs.data) {
    t1 = props.logs.data.length > 0 ? props.logs.data.map(_temp2) : <div className="font-color-silver">No logs found</div>;
    $[1] = props.logs.data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.logs.count || $[4] !== props.logs.page || $[5] !== props.setPage) {
    t2 = props.logs.count > 0 && props.logs.count / 10 > 1 && <div className="text-center mt-3"><Pagination page={props.logs.page} pageSize={10} totalResults={props.logs.count} setPage={props.setPage} /></div>;
    $[3] = props.logs.count;
    $[4] = props.logs.page;
    $[5] = props.setPage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t0}<Accordion.Body className={styles.topUpHistoryAccordionBody}><div className="d-flex flex-column gap-2">{t1}{t2}</div></Accordion.Body></Accordion.Item></Accordion>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp2(log) {
  return <LogEntry key={`subscription-log-${log.id}`} log={log} />;
}
function TopUpAccordion(props) {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Accordion.Button className={styles.topUpHistoryAccordionButton}><b>Top Up History</b></Accordion.Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.history.data) {
    t1 = props.history.data.length > 0 ? props.history.data.map(_temp3) : <div className="font-color-silver">No Top Ups found</div>;
    $[1] = props.history.data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="d-flex flex-column gap-2">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.history.count || $[6] !== props.history.page || $[7] !== props.setPage) {
    t3 = props.history.count > 0 && props.history.count / 10 > 1 && <div className="text-center mt-3"><Pagination page={props.history.page} pageSize={10} totalResults={props.history.count} setPage={props.setPage} /></div>;
    $[5] = props.history.count;
    $[6] = props.history.page;
    $[7] = props.setPage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t0}<Accordion.Body className={styles.topUpHistoryAccordionBody}>{t2}{t3}</Accordion.Body></Accordion.Item></Accordion>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp3(topUp) {
  return <TopUpEntry key={topUp.hash} topUp={topUp} />;
}
function TopUpEntry(props) {
  const $ = _c(25);
  let t0;
  if ($[0] !== props.topUp.amount) {
    t0 = <b>+ {props.topUp.amount}</b>;
    $[0] = props.topUp.amount;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5"><EthereumIcon /></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <div className="d-flex align-items-center gap-1 no-wrap">{t0}{t1}</div>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.topUp.from_wallet) {
    t3 = <span>from: {props.topUp.from_wallet}</span>;
    $[5] = props.topUp.from_wallet;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="d-flex align-items-center gap-3">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props.topUp.transaction_date) {
    t5 = getDateDisplay(new Date(props.topUp.transaction_date));
    $[10] = props.topUp.transaction_date;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <div className="font-color-silver no-wrap">{t5}</div>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== props.topUp.hash) {
    t7 = getTransactionLink(mainnet.id, props.topUp.hash);
    $[14] = props.topUp.hash;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <EtherscanIcon />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7) {
    t9 = <div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5"><a className="d-flex align-items-center" target="_blank" rel="noopener noreferrer" href={t7} aria-label="View transaction on Etherscan">{t8}</a></div>;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="d-flex align-items-center gap-3">{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4) {
    t11 = <div className={styles.subscriptionHistoryEntry}><div className="d-flex align-items-center justify-content-between gap-2">{t4}{t10}</div></div>;
    $[22] = t10;
    $[23] = t4;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function LogEntry(props) {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.log.log) {
    t0 = <div>{props.log.log}</div>;
    $[0] = props.log.log;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.log.additional_info) {
    t1 = props.log.additional_info && <div className="font-smaller font-color-silver">{props.log.additional_info}</div>;
    $[2] = props.log.additional_info;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="d-flex flex-column gap-1">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.log.created_at) {
    t3 = props.log.created_at && getDateDisplay(new Date(props.log.created_at));
    $[7] = props.log.created_at;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="d-flex align-items-center gap-3"><div className="font-color-silver no-wrap">{t3}</div></div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <div className={styles.subscriptionHistoryEntry}><div className="d-flex align-items-center justify-content-between gap-2">{t2}{t4}</div></div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function RedeemedEntry(props) {
  const $ = _c(30);
  let t0;
  if ($[0] !== props.redeem.contract) {
    t0 = areEqualAddresses(props.redeem.contract, MEMES_CONTRACT) ? "Meme" : `Contract ${formatAddress(props.redeem.contract)}`;
    $[0] = props.redeem.contract;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const contractName = t0;
  let t1;
  if ($[2] !== contractName || $[3] !== props.redeem.count || $[4] !== props.redeem.token_id) {
    t1 = <div>Redeemed Subscription for {contractName} #{props.redeem.token_id} x{props.redeem.count}</div>;
    $[2] = contractName;
    $[3] = props.redeem.count;
    $[4] = props.redeem.token_id;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props.redeem.address) {
    t2 = formatAddress(props.redeem.address);
    $[6] = props.redeem.address;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props.redeem.balance_after || $[9] !== t2) {
    t3 = <div className="font-smaller font-color-silver">Airdrop Address: {t2} - Balance after redemption: {props.redeem.balance_after} ETH</div>;
    $[8] = props.redeem.balance_after;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t3) {
    t4 = <div className="d-flex flex-column gap-1">{t1}{t3}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== props.redeem.created_at || $[15] !== props.redeem.transaction_date) {
    t5 = (props.redeem.transaction_date ?? props.redeem.created_at) && getDateDisplay(new Date((props.redeem.transaction_date ?? props.redeem.created_at) as Date));
    $[14] = props.redeem.created_at;
    $[15] = props.redeem.transaction_date;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t5) {
    t6 = <div className="font-color-silver no-wrap">{t5}</div>;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== props.redeem.transaction) {
    t7 = getTransactionLink(mainnet.id, props.redeem.transaction);
    $[19] = props.redeem.transaction;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <EtherscanIcon />;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7) {
    t9 = <div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5"><a className="d-flex align-items-center" target="_blank" rel="noopener noreferrer" href={t7} aria-label="View transaction on Etherscan">{t8}</a></div>;
    $[22] = t7;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t6 || $[25] !== t9) {
    t10 = <div className="d-flex align-items-center gap-3">{t6}{t9}</div>;
    $[24] = t6;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t4) {
    t11 = <div className={styles.subscriptionHistoryEntry}><div className="d-flex align-items-center justify-content-between gap-2">{t4}{t10}</div></div>;
    $[27] = t10;
    $[28] = t4;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}